import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { catalogImportTranslationRef } from '@backstage/plugin-catalog-import/alpha';

const en = createTranslationMessages({
  ref: catalogImportTranslationRef,
  full: false,
  messages: {
    'defaultImportPage.headerTitle': 'Import a new service',
    'defaultImportPage.contentHeaderTitle':
      'Start tracking your service in {{ appTitle }}',
    'defaultImportPage.supportTitle':
      'Start tracking your service in {{appTitle}} by adding it to the software catalog.',
    'importInfoCard.title': 'Register an existing service',
    'stepInitAnalyzeUrl.urlHelperText':
      'Enter the full path to your entity file to start tracking your service',
    'importStepper.noLocation.createPr.componentNameLabel':
      'Name of the created service',
    'importStepper.noLocation.createPr.componentNamePlaceholder': 'my-service',
    'stepFinishImportLocation.locations.viewButtonText': 'View Service',
  },
});

export const catalogImportTranslations = createTranslationResource({
  ref: catalogImportTranslationRef,
  translations: {
    en: async () => ({ default: en }),
  },
});
